<template>
  <div class="app-container shopType">
    <div class="typeHeader">
      <el-button size="small" type="primary" @click="onAdd">新增</el-button>
    </div>

    <el-dialog :title="title" v-if="showDialog" :visible.sync="showDialog">
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="包名">
          <el-input
            v-model="form.name"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入包名"
          ></el-input>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number
            v-model="form.sort"
            :min="1"
          ></el-input-number>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleCancel">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmit"
            type="primary"
            :loading="btnLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-table
      :data="list"
      :loading="listLoading"
      border
      fit
      highlight-current-row
      style="margin-top: 15px"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column align="center" label="课程系列名称" width="95">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
        <el-table-column align="center" label="权重" min-width="110">
        <template slot-scope="scope">{{ scope.row.sort}}</template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="110">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.state == 1">上架中</el-tag>
          <el-tag type="warning" v-else>已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="400">
        <template slot-scope="scope">
          <el-button size="small" @click="onEdit(scope.row)">修改</el-button>
          <el-button
            size="small"
            :type="scope.row.state == 1 ? 'warning' : 'success'"
            @click="handleUpShelf(scope.row)"
            >{{ scope.row.state == 1 ? "下架" : "上架" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      listLoading: true,
      total: null,
      listQuery: {
        page: 1,
        limit: 10,
      },
      form: {
        id:'',
        name:'',
        type:'',
        energy:'',
        original_price:'',
        final_price:''
      },
      jumpList:[
        {id:1,name:'普通'},
        {id:2,name:'限制'},
      ],
      showDialog: false,
      btnLoading: false,
      title: "", // dialog显示的标题
      list: [],
      schools: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onAdd() {
      this.title = "新增类型";
      this.resetData();
      this.showDialog = true;
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/CourseTypeList",
        method: "get",
        params: this.listQuery,
      })
        .then((result) => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((err) => {
          console.log(err);
        });
    },
    resetData() {
      this.form = {
        id:'',
        name:'',
        type:'',
        energy:'',
        original_price:'',
        final_price:''
      };
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getList();
    },
    handleCancel() {
      this.btnLoading = false;
      this.showDialog = false;
    },
    handleSubmit() {
      if (!this.form.name) {
        this.$message({
          type: "error",
          message: "请填写包名!",
        });
        return;
      } 
      this.btnLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/CourseTypeAdd",
            method: "post",
            data: this.form,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.btnLoading = false;
              this.showDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.btnLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleUpShelf(row) {
      let self = this;
      let state = !row.status ? "上架" : "下架";
      self
        .$confirm(`此操作将会${state}该商品类型，是否继续`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then((result) => {
          request({
            url: "/api/backend/CourseTypeState",
            method: "post",
            data: {
              id: row.id,
            },
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
        });
    },

  
    onEdit(row) {
      this.title = "修改";
      this.form = Object.assign({}, row);
      this.showDialog = true;
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.typeHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
=